import en from './resources/en';
import de from './resources/de';

const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

export default resources;
